import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import DecorpotLogo from "../assets/img/org/deco_new_logo.png";
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import HttpService from "../services/httpService";
import {
    TextField,
    Button,
    Grid,
    Paper,
    AccordionDetails,
    TableContainer,
    Table,
    TableCell,
    TableRow,
    MenuItem,
    TableBody,
    FormControl,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    surveyform: {
        backgroundColor: "#f0ebf8",
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
    textFieldWidth: {
        width: "100%",
    },
    buttonGroup: {
        display: "flex",
        justifyContent: "flex-end",
        gap: theme.spacing(2),
        marginTop: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column", // stack buttons on mobile
            gap: theme.spacing(1),
        },
    },
}));

// This form is public-facing, so raw backend error text must never reach it
// verbatim: some messages name another real customer ("...already exists for
// customer: X"), others are internal staffing/assignment language ("No
// Assistant Sales Manager found...") meant for ops, not whoever's filling out
// this form. Known-safe cases get a sanitized, actionable message; anything
// unrecognized (including future backend message changes) falls back to a
// generic retry message instead of being shown as-is.
const sanitizeReferralErrorMessage = (rawMessage) => {
    if (!rawMessage) return 'Something went wrong. Please try again.';
    if (/primary contact already exists/i.test(rawMessage)) {
        return 'This phone number is already registered with us.';
    }
    if (/primary email already exists/i.test(rawMessage)) {
        return 'This email address is already registered with us.';
    }
    if (/invalid primary email address/i.test(rawMessage)) {
        return 'Please enter a valid email address.';
    }
    return 'We were unable to submit your referral right now. Please try again in a little while.';
};

const ReferralClientForm = (props) => {
    const classes = useStyles();
    const { leadId } = useParams();
    const [leadDetails, setLeadDetail] = useState();
    const [commonExpCenter, setCommonExpCenter] = useState([]);
    const [selectedExCenter, setSelectedExCenter] = useState('')
    const [selectedExpId, setSelectedExpId] = useState('')
    const [commonUser, setCommonUser] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState('');
    const [selectedUser, setSelectedUser] = useState('')
    const [formData, setFormData] = useState({
        referrerName: '',
        phone: '',
        referrerEmail: ''
    });


    useEffect(() => {
        getExpeCenter();
    }, [])

    // get all exp center name
    const getExpeCenter = async () => {
        let exCenter = await HttpService.getExpericenCenters();
        let response = await HttpService.getLeadDetails(leadId);
        setLeadDetail(response?.data);
        setCommonExpCenter(exCenter?.data);
    }

    // handle exp Center
    const handleExpCenter = async (e, value) => {
        setSelectedExCenter(value?.name);
        setSelectedExpId(value?._id);

        let obj = {
            role: "Sales User",
            pivotValue: `${value?._id} Referral_Client`,
        };

        try {
            let userData = await HttpService.getSelectedUsersBasedOnRoles(obj);
            setCommonUser(userData?.data);
        } catch (err) {
            console.error("Error fetching users:", err);
        }
    };


    // handle phone number and name
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "phone") {
            const onlyDigits = value.replace(/\D/g, "");
            if (onlyDigits.length <= 10) {
                setFormData((prev) => ({
                    ...prev,
                    [name]: onlyDigits,
                }));
            }
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    // handle submit
    const handleSubmit = async () => {
        props.setLoading(true);
        try {
            const { uniqueLeadNumber, customerId: { contact_no, _id, name } } = leadDetails;
            let obj = {
                name: formData.referrerName,
                contact_no: formData.phone,
                email: formData.referrerEmail,
                experienceCenterId: selectedExpId,
                selectedUser: selectedUser,
                selectedUserId: selectedUserId,
                referredByCxUniqueLeadNumber: uniqueLeadNumber,
                referredByCxName: name,
                referredByCxMobile: contact_no,
                referredCxId: _id,
            }
            let response = await HttpService.getLeadCreated(obj);
            if (response.status === 200) {
                props.setSnackInfo('Form submitted successfully!', 'success');
            }

            setFormData({
                referrerName: '',
                phone: '',
                referrerEmail: ''
            })
            setSelectedExCenter('');
            setSelectedExpId('');
            setSelectedUser('');
            setSelectedUserId('');
        } catch (err) {
            console.error(err);
            const rawMessage = err?.response?.data?.error || err?.response?.data?.message;
            props.setSnackInfo(sanitizeReferralErrorMessage(rawMessage), 'error');
        }
        props.setLoading(false);
    };

    return (
        <div>
            <div style={{ margin: "50px auto", width: "90%" }}>
                <Grid container justifyContent="center" style={{ margin: "50px auto" }}>
                    <Grid item xs={12} md={8} lg={6}>
                        <AccordionDetails style={{ padding: "8px 0px 16px" }}>
                            <TableContainer component={Paper}>

                                <Table className={classes.table} aria-label="customized table">
                                    <TableBody>
                                        {/* Logo + Heading Row */}
                                        <TableRow>
                                            <TableCell colSpan={2} style={{ textAlign: "center", padding: "20px" }}>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <img
                                                        src={DecorpotLogo}
                                                        alt="decorpot logo"
                                                        height={100}
                                                        style={{ marginBottom: "10px" }}
                                                    />
                                                    <h2 style={{ margin: 0 }}>Customer Referral Form</h2>
                                                </div>
                                            </TableCell>
                                        </TableRow>

                                        <TableRow key="1">
                                            <TableCell>
                                                <FormControl style={{ width: "100%" }}>
                                                    <TextField
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        label="Customer's Name"
                                                        name="referrerName"
                                                        fullWidth
                                                        value={formData.referrerName}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>

                                        <TableRow key="2">
                                            <TableCell>
                                                <FormControl style={{ width: "100%" }}>
                                                    <TextField
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        label="Cx Contact Number"
                                                        //   size="small"
                                                        fullWidth
                                                        name="phone"
                                                        value={formData.phone}
                                                        onChange={handleChange}
                                                        required
                                                        className={classes.textField}
                                                        inputProps={{
                                                            maxLength: 10,
                                                            inputMode: "numeric"
                                                        }}
                                                        error={formData.phone.length > 0 && formData.phone.length !== 10}
                                                        helperText={
                                                            formData.phone.length > 0 && formData.phone.length !== 10
                                                                ? "Phone number must be number and exactly 10 digits"
                                                                : ""
                                                        }
                                                    />
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>

                                        <TableRow key="3">
                                            <TableCell>
                                                <FormControl style={{ width: "100%" }}>
                                                    <TextField
                                                        id="outlined-basic"
                                                        fullWidth
                                                        label="Customer's Email"
                                                        type="email"
                                                        name="referrerEmail"
                                                        value={formData.referrerEmail}
                                                        onChange={handleChange}
                                                        variant="outlined"
                                                        required
                                                    />
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>

                                        <TableRow key="4">
                                            <TableCell>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        select
                                                        name="exp-center-select"
                                                        value={selectedExCenter || ""}
                                                        onChange={(e) => handleExpCenter(e, commonExpCenter.find(ec => ec.name === e.target.value))}
                                                        label="Select Exp-Center (optional)"
                                                        variant="outlined"
                                                    >
                                                        {commonExpCenter && commonExpCenter.map((option, index) => (
                                                            <MenuItem key={index} value={option.name}>
                                                                {option.name}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>

                                        <TableRow key="5">
                                            <TableCell>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        select
                                                        name="preferred-person-select"
                                                        value={selectedUser || ""}
                                                        onChange={(e) => {
                                                            const user = commonUser.find(u => u.name === e.target.value);
                                                            setSelectedUser(user?.name);
                                                            setSelectedUserId(user?._id);
                                                        }}
                                                        label="Preferred Person to Connect in Sales (optional)"
                                                        variant="outlined"
                                                    // size="small"
                                                    >
                                                        {commonUser && commonUser.map((option, index) => (
                                                            <MenuItem key={index} value={option.name}>
                                                                {option.name}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>

                                        <TableRow key="6">
                                            <TableCell>
                                                <div className={classes.buttonGroup}>
                                                    <Button variant="contained" color="secondary">
                                                        Cancel
                                                    </Button>
                                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={!formData.referrerName || !formData.phone || !formData.referrerEmail}>
                                                        Submit Referral
                                                    </Button>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </AccordionDetails>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default connect(null, { setLoading, setSnackInfo })(ReferralClientForm);
